import classNames from 'classnames'

type Props = {
  id: string
  name: string
  labelComponent?: JSX.Element | JSX.Element[]
  label?: string
  helpText?: string
  errorText?: string
  checked?: boolean
  size?: 'sm' | 'md' | 'lg'
  isRounded?: boolean
  readOnly?: boolean
  handleCheckboxChange?: (e: React.FormEvent<HTMLInputElement>) => void
} & typeof defaultProps

const defaultProps = {
  label: '',
  helpText: '',
  errorText: '',
  checked: false,
}
const Checkbox = ({
  name,
  labelComponent,
  label,
  helpText,
  errorText,
  size = 'md',
  checked,
  readOnly,
  isRounded = false,
  handleCheckboxChange,
}: Props): JSX.Element => (
  <div>
    <label className="text-grey flex items-baseline lg:items-center text-sm">
      <input
        className={classNames('form-checkbox cursor-pointer flex', {
          'h-4 w-4': size === 'md',
          'h-8 w-8': size === 'lg',
          'rounded-full': isRounded,
        })}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={handleCheckboxChange}
        readOnly={readOnly}
      />
      {label && <span className="pl-3">{label}</span>}
      {labelComponent && <div className="pl-3">{labelComponent}</div>}
    </label>
    {helpText && (
      <div className="text-grey text-sm font-400 py-2">{helpText}</div>
    )}
    {errorText && (
      <div className="text-red-200 text-sm font-400 py-2">{errorText}</div>
    )}
  </div>
)

Checkbox.defaultProps = defaultProps
export default Checkbox
